import React, { memo } from 'react'
import { MenuItem, MenuList } from '@mui/material'
import { faChevronDown } from '@fortawesome/pro-duotone-svg-icons'
import { usePopover } from 'minimal-shared/hooks'

import { CustomPopover } from '../shared/custom-popover'
import Button from '../shared/button/Button'
import FaIcon from 'src/components/shared/faIcon/FaIcon'

const SelectPerkActions = ({ t, productId, onSelectPerk, disabled }) => {
  const menuActions = usePopover()
  const renderMenuActions = () => (
    <CustomPopover
      open={menuActions.open}
      anchorEl={menuActions.anchorEl}
      onClose={menuActions.onClose}
      slotProps={{ arrow: { placement: 'top-right' } }}
    >
      <MenuList>
        {productId.map((id) => {
          const name = t(`brand:perk.gaming-options.${id}`)
          return (
            <MenuItem
              key={id}
              onClick={() => {
                menuActions.onClose()
                onSelectPerk({ id, name })
              }}
            >
              {name}
            </MenuItem>
          )
        })}
      </MenuList>
    </CustomPopover>
  )
  return (
    <>
      <Button
        color='inherit'
        size='small'
        endIcon={<FaIcon icon={faChevronDown} size='xs' />}
        onClick={menuActions.onOpen}
        label={t('brand:perk.select')}
        sx={{ width: 88 }}
        disabled={disabled}
      />
      {renderMenuActions()}
    </>
  )
}

export default memo(SelectPerkActions)
